import React, { FC } from 'react';

type SectionMSBookingsFormProps = {
  src: string;
};

const SectionMSBookingsForm: FC<SectionMSBookingsFormProps> = ({src}) => {
  return (
    <iframe
      src={src}
      width="100%"
      height="960px"
      scrolling="auto"
      style={{background:'#ffffff', border: 0 }}
    ></iframe>
  );
};

export default SectionMSBookingsForm;
